// SSO 单点登录回调页（SsoCallback.vue）相关词条
export const ssoCN = {
    'Sso.Callback.Loading': '正在登录...',
    'Sso.Callback.Back.To.Login': '返回登录',
    'Sso.Callback.Success.Redirecting': '登录成功，正在跳转...',
    'Sso.Callback.Error.No.Code': '未收到授权码，登录中断',
    'Sso.Callback.Error.State.Mismatch': 'State 校验失败：疑似 CSRF 攻击',
    'Sso.Callback.Error.Missing.Verifier': '缺少 PKCE code_verifier，请重试',
    'Sso.Callback.Error.Auth.Failed': 'SSO 授权失败：{detail}',
    'Sso.Callback.Error.Token.Exchange.Failed': '令牌交换失败（{status}）',
    'Sso.Callback.Error.Jwt.Missing.Uuid': 'JWT 缺少 uuid subject',
    'Sso.Callback.Error.Exception': 'SSO 回调异常：{detail}',
};

export const ssoUS = {
    'Sso.Callback.Loading': 'Signing in...',
    'Sso.Callback.Back.To.Login': 'Back to login',
    'Sso.Callback.Success.Redirecting': 'Sign-in successful, redirecting...',
    'Sso.Callback.Error.No.Code': 'No authorization code received, login aborted',
    'Sso.Callback.Error.State.Mismatch': 'State mismatch: possible CSRF attack',
    'Sso.Callback.Error.Missing.Verifier': 'Missing PKCE code_verifier, please try again',
    'Sso.Callback.Error.Auth.Failed': 'SSO authorization failed: {detail}',
    'Sso.Callback.Error.Token.Exchange.Failed': 'Token exchange failed ({status})',
    'Sso.Callback.Error.Jwt.Missing.Uuid': 'JWT missing uuid subject',
    'Sso.Callback.Error.Exception': 'SSO callback exception: {detail}',
};
